module.exports = __webpack_public_path__ + "img/imagen5.9fd553f0.png";